/* =========================================================================
   Kitsters Homepage - vanilla JS
   No framework. Progressive enhancement; everything works server-rendered too.
   ========================================================================= */
(function () {
  'use strict';

  /* ---------- 1. Announcement bar - rotate messages, dismiss ---------- */
  function initAnnouncement() {
    var bar = document.querySelector('[data-ann]');
    if (!bar) return;
    var msgs = bar.querySelectorAll('[data-ann-msg]');
    var close = bar.querySelector('[data-ann-close]');
    if (msgs.length > 1) {
      var i = 0;
      // explicit start state for first message
      msgs[0].style.display = '';
      msgs[0].style.opacity = '1';
      setInterval(function () {
        var current = msgs[i];
        current.style.opacity = '0';
        setTimeout(function () {
          current.style.display = 'none';
          i = (i + 1) % msgs.length;
          var next = msgs[i];
          next.style.opacity = '0';
          next.style.display = '';
          // force reflow so the browser registers opacity:0 before we go to 1
          void next.offsetHeight;
          // double-RAF guarantees a frame between the two opacity values
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { next.style.opacity = '1'; });
          });
        }, 280);
      }, 4500);
    } else if (msgs.length === 1) {
      msgs[0].style.display = '';
      msgs[0].style.opacity = '1';
    }
    if (close) {
      close.addEventListener('click', function () {
        bar.style.display = 'none';
        try { sessionStorage.setItem('kitsters-ann-dismissed', '1'); } catch (e) {}
      });
      try {
        if (sessionStorage.getItem('kitsters-ann-dismissed') === '1') bar.style.display = 'none';
      } catch (e) {}
    }
  }

  /* ---------- 2. Mobile drawer ---------- */
  function initDrawer() {
    var openBtn = document.querySelector('[data-drawer-open]');
    var drawer = document.querySelector('[data-drawer]');
    if (!openBtn || !drawer) return;
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    var backdrop = drawer;
    var open = function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var close = function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', function (e) { if (e.target === backdrop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- 3. Hero slider - autoplay, dots, swipe, pause, counter ---------- */
  function initHero() {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;
    var slides     = hero.querySelectorAll('[data-hero-slide]');
    var dots       = hero.querySelectorAll('[data-hero-dot]');
    var prevBtn    = hero.querySelector('[data-hero-prev]');
    var nextBtn    = hero.querySelector('[data-hero-next]');
    var idx    = 0;
    var timer  = null;
    var paused = false;
    var INTERVAL = 5500;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Set up canplay listeners so each video fades in once buffered enough to play
    slides.forEach(function (s) {
      var vid = s.querySelector('.hero__video');
      if (vid) {
        vid.addEventListener('canplay', function () { vid.classList.add('is-ready'); });
      }
    });

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(function () { go(idx + 1); }, INTERVAL);
    }
    function stopTimer() { clearInterval(timer); timer = null; }
    function reset() { if (!paused) startTimer(); }

    function playVideo(vid) {
      if (!vid || prefersReduced) return;
      if (!vid.src && vid.dataset.videoSrc) { vid.src = vid.dataset.videoSrc; }
      vid.play().catch(function () {});
    }

    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var active = i === idx;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        var vid = s.querySelector('.hero__video');
        if (vid) { active ? playVideo(vid) : vid.pause(); }
      });
      dots.forEach(function (d, i) {
        var active = i === idx;
        if (active) {
          // remove then re-add to restart the CSS progress animation
          d.classList.remove('is-active');
          void d.offsetHeight;
        }
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      // preload the next slide image while the current one is showing
      var nextIdx = (idx + 1) % slides.length;
      var nextImg = slides[nextIdx] && slides[nextIdx].querySelector('img');
      if (nextImg && !nextImg.dataset.preloaded) {
        nextImg.dataset.preloaded = '1';
        (new Image()).src = nextImg.currentSrc || nextImg.src;
      }
    }

    function setPaused(p) {
      paused = p;
      var activeVid = slides[idx] && slides[idx].querySelector('.hero__video');
      if (p) {
        stopTimer();
        if (activeVid) activeVid.pause();
      } else {
        startTimer();
        if (activeVid) playVideo(activeVid);
      }
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); reset(); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); reset(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); reset(); });

    // swipe
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) { dx < 0 ? go(idx + 1) : go(idx - 1); reset(); }
      x0 = null;
    });

    // keyboard
    hero.tabIndex = 0;
    hero.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(idx + 1); reset(); }
      if (e.key === 'ArrowLeft')  { go(idx - 1); reset(); }
    });

    // pause on hover (respect manual pause state)
    hero.addEventListener('mouseenter', function () { if (!paused) stopTimer(); });
    hero.addEventListener('mouseleave', function () { if (!paused) startTimer(); });

    // pause when scrolled out of view
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!paused) {
            var activeVid = slides[idx] && slides[idx].querySelector('.hero__video');
            if (e.isIntersecting) {
              startTimer();
              if (activeVid) playVideo(activeVid);
            } else {
              stopTimer();
              if (activeVid) activeVid.pause();
            }
          }
        });
      }, { threshold: 0.2 }).observe(hero);
    }

    go(0); startTimer();
  }

  /* ---------- 4. Add to cart - bump badge + toast ---------- */
  function initCart() {
    var badge = document.querySelector('[data-cart-count]');
    var toast = document.querySelector('[data-toast]');
    var toastText = toast ? toast.querySelector('[data-toast-text]') : null;
    var toastClose = toast ? toast.querySelector('[data-toast-close]') : null;
    var count = 0;
    var t;

    // Visibility is owned by the .is-empty class in kitsters-header.css - never write
    // badge.style.display here. An inline `display: flex` beats every stylesheet rule,
    // which (a) made text-align:center a no-op and shifted the digit ~3px left of centre
    // on the homepage only, and (b) would out-rank .is-empty { display: none } and strand
    // a stale badge when the cart empties.
    function showBadge(n) {
      if (!badge) return;
      badge.textContent = n;
      badge.classList.toggle('is-empty', !(n > 0));
    }

    // Seed count from real Shopify cart so badge starts accurate
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      count = cart.item_count || 0;
      if (count > 0) showBadge(count);
    }).catch(function () {});

    function bumpBadge() {
      if (!badge) return;
      showBadge(count);
      badge.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }],
        { duration: 360, easing: 'cubic-bezier(0.34,1.56,0.64,1)' }
      );
    }

    function showToast(msg) {
      if (!toast) return;
      toastText.textContent = msg;
      // Force animation replay by toggling the class
      toast.classList.remove('is-open');
      void toast.offsetWidth;
      toast.classList.add('is-open');
      clearTimeout(t);
      t = setTimeout(function () { toast.classList.remove('is-open'); }, 4000);
    }
    if (toastClose) toastClose.addEventListener('click', function () { toast.classList.remove('is-open'); clearTimeout(t); });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      var name = btn.getAttribute('data-name') || 'Item';
      if (!variantId) { showToast(name + ' added!'); return; }

      // Optimistic: update UI immediately
      count += 1;
      bumpBadge();
      showToast(name + ' added to cart!');
      btn.disabled = true;

      // Include the drawer section ID so Shopify returns rendered drawer HTML
      // in the add response - required for the cart:update event to re-render the drawer.
      var drawerEl = document.querySelector('hdt-cart-drawer');
      var sectionId = drawerEl ? drawerEl.getAttribute('section-id') : null;
      var payload = { id: parseInt(variantId, 10), quantity: 1 };
      if (sectionId) payload.sections = [sectionId];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart_add_failed');
          return r.json();
        })
        .then(function (addData) {
          // Fire cart:update so the hdt-cart-drawer re-renders and opens.
          // The drawer listens for this event, rebuilds its HTML from the
          // sections payload, then calls this.open() when actionAfterATC is
          // 'open_cart_drawer' and source is 'product-form-component'.
          if (sectionId && addData.sections) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                cartData: addData,
                source: 'product-form-component',
                actionAfterATC: 'open_cart_drawer'
              }
            }));
          }
          // Sync real count from Shopify for the local badge
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          count = cart.item_count || count;
          bumpBadge();
        })
        .catch(function () {
          // Roll back optimistic update
          count = Math.max(0, count - 1);
          bumpBadge();
          showToast('Could not add to cart - please try again');
        })
        .finally(function () { btn.disabled = false; });
    });
  }

  /* ---------- 5. Wishlist ---------- */
  function initWishlist() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist]');
      if (!btn) return;
      e.preventDefault();
      btn.classList.toggle('is-on');
    });
  }

  /* ---------- 6. Scroll reveal ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    document.documentElement.classList.add('kh-reveal-ready');
  }

  /* ---------- 7. Newsletter ---------- */
  function initNewsletter() {
    var form = document.querySelector('[data-newsletter]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type=email]');
      var btn = form.querySelector('button');
      if (!input || !input.value) return;
      // Let the native Shopify customer form POST proceed - do NOT preventDefault.
      // Update the button text optimistically so the user gets immediate feedback
      // while the page navigates / Shopify processes the subscription.
      btn.textContent = 'Welcome! ✨';
      btn.disabled = true;
    });
  }

  /* ---------- 8. Delivery ETA countdown ---------- */
  function initEta() {
    var el = document.querySelector('[data-eta-countdown]');
    var dayEl = document.querySelector('[data-eta-day]');
    if (!el) return;
    // cutoff = today 6 PM IST
    function update() {
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(18, 0, 0, 0);
      if (now > cutoff) cutoff.setDate(cutoff.getDate() + 1);
      var diff = cutoff - now;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      el.textContent = h + 'h ' + (m < 10 ? '0' + m : m) + 'm';
      if (dayEl) {
        var delivery = new Date(now);
        // estimate: order before cutoff → +2 days, else +3
        delivery.setDate(delivery.getDate() + (now < cutoff ? 2 : 3));
        var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
        dayEl.textContent = days[delivery.getDay()];
      }
    }
    update();
    setInterval(update, 30000);
  }

  /* ---------- 9. Back to top ---------- */
  function initBackToTop() {
    var btn = document.querySelector('[data-back-top]');
    if (!btn) return;
    function toggle() {
      btn.classList.toggle('is-visible', window.scrollY > 400);
    }
    document.addEventListener('scroll', toggle, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    toggle();
  }

  /* ---------- 11. Wordmark fill on scroll into view ---------- */
  function initWordmarkFill() {
    var wm = document.querySelector('[data-footer-wordmark]');
    if (!wm || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        wm.classList.toggle('is-filled', en.isIntersecting);
      });
    }, { threshold: 0.3 });
    io.observe(wm);
  }

  /* ---------- 11b. Corporate stat count-up ----------
     Progressive enhancement only: the real figure is already in the HTML, and this reads it,
     counts up to it, then restores the exact original string. Bails out entirely on no-IO or
     reduced-motion, in which case the number just sits there correct. Uses its own
     `data-corp-count` attribute rather than the `data-countup` that gifting/magic-hour use,
     so those scripts and this one can never fight over the same nodes. */
  function initCorpCounters() {
    var nums = document.querySelectorAll('[data-corp-count]');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);

        var el = en.target;
        var full = el.textContent.trim();
        /* "200+" -> 200 / "+"   ·   "30K+" -> 30 / "K+" */
        var parts = full.match(/^(\d+(?:\.\d+)?)(.*)$/);
        if (!parts) return;
        var target = parseFloat(parts[1]);
        var suffix = parts[2];
        var decimals = (parts[1].split('.')[1] || '').length;
        var start = null;
        var DUR = 900;

        function frame(now) {
          if (start === null) start = now;
          var p = Math.min((now - start) / DUR, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          if (p < 1) {
            el.textContent = (target * eased).toFixed(decimals) + suffix;
            requestAnimationFrame(frame);
          } else {
            el.textContent = full;   /* restore verbatim - never re-format the owner's copy */
          }
        }
        el.textContent = (0).toFixed(decimals) + suffix;
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.4 });

    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- 12. Footer newsletter ---------- */
  function initFooterNewsletter() {
    var form = document.querySelector('[data-footer-newsletter]');
    if (!form) return;
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button');
      if (btn) { btn.textContent = 'Magic incoming! ✨'; btn.disabled = true; }
    });
  }

  /* ---------- 10. Scroll-snap carousels (magic slider, blog, reviews) ---------- */
  function initScrollCarousels() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setupCarousel(opts) {
      var track = opts.track;
      if (!track) return;
      var prevBtn = opts.prev || null;
      var nextBtn = opts.next || null;
      var dots = opts.dots || [];
      var interval = opts.interval || 4000;
      var current = 0;
      var total = dots.length;
      var timer;

      function cardWidth() {
        var card = track.firstElementChild;
        if (!card) return track.offsetWidth;
        var gap = parseInt(getComputedStyle(track).gap) || 0;
        return card.offsetWidth + gap;
      }

      function goToDot(index) {
        current = index;
        track.scrollTo({ left: track.offsetWidth * index, behavior: reduced ? 'auto' : 'smooth' });
        dots.forEach(function(d, i) { d.classList.toggle('active', i === index); });
      }

      function advance(dir) {
        if (total > 0) {
          goToDot((current + dir + total) % total);
        } else {
          var maxScroll = track.scrollWidth - track.clientWidth;
          if (dir > 0 && track.scrollLeft >= maxScroll - 4) {
            track.scrollTo({ left: 0, behavior: reduced ? 'auto' : 'smooth' });
          } else {
            track.scrollBy({ left: dir * cardWidth(), behavior: reduced ? 'auto' : 'smooth' });
          }
        }
      }

      function startAuto() {
        if (reduced) return;
        clearInterval(timer);
        timer = setInterval(function() { advance(1); }, interval);
      }

      dots.forEach(function(btn) {
        btn.addEventListener('click', function() {
          clearInterval(timer);
          goToDot(parseInt(btn.dataset.index));
          startAuto();
        });
      });
      if (prevBtn) prevBtn.addEventListener('click', function() { clearInterval(timer); advance(-1); startAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { clearInterval(timer); advance(1); startAuto(); });

      track.addEventListener('mouseenter', function() { clearInterval(timer); });
      track.addEventListener('mouseleave', startAuto);
      track.addEventListener('focusin', function() { clearInterval(timer); });
      track.addEventListener('focusout', startAuto);

      startAuto();
    }

    // Magic Hour slider
    var magicTrack = document.getElementById('magicSliderTrack');
    if (magicTrack) {
      setupCarousel({
        track: magicTrack,
        dots: Array.from(document.querySelectorAll('#magicSliderDots button')),
        interval: 3500
      });
    }

    // Corporate offsite slider (reuses the magic slider markup/CSS)
    var corpTrack = document.getElementById('corpSliderTrack');
    if (corpTrack) {
      setupCarousel({
        track: corpTrack,
        dots: Array.from(document.querySelectorAll('#corpSliderDots button')),
        interval: 3800
      });
    }

    // Blog carousel
    var blogTrack = document.getElementById('blogTrack');
    if (blogTrack) {
      var blogSection = blogTrack.closest('.blog');
      setupCarousel({
        track: blogTrack,
        prev: blogSection && blogSection.querySelector('.blog__arrow--prev'),
        next: blogSection && blogSection.querySelector('.blog__arrow--next'),
        interval: 4000
      });
    }

    // Reviews carousel
    var reviewsTrack = document.getElementById('reviewsTrack');
    if (reviewsTrack) {
      var reviewsSection = reviewsTrack.closest('.reviews');
      setupCarousel({
        track: reviewsTrack,
        prev: reviewsSection && reviewsSection.querySelector('.reviews__arrow--prev'),
        next: reviewsSection && reviewsSection.querySelector('.reviews__arrow--next'),
        interval: 5000
      });
    }
  }

  /* ---------- Our Story image - pointer-follow 3D tilt ---------- */
  function initStoryTilt() {
    var card = document.querySelector('[data-tilt]');
    if (!card) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (prefersReduced || !hoverCapable) return; /* touch/coarse pointers: leave the static card as-is */

    var maxTilt = 14; /* degrees, at the card's edge */
    var raf = null;

    function onMove(e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;  /* 0 (left) .. 1 (right) */
      var y = (e.clientY - rect.top) / rect.height;  /* 0 (top) .. 1 (bottom) */
      var rotateY = (x - 0.5) * (maxTilt * 2);
      var rotateX = (0.5 - y) * (maxTilt * 2);
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.style.transform = 'perspective(900px) rotateX(' + rotateX.toFixed(2) + 'deg) rotateY(' + rotateY.toFixed(2) + 'deg) scale3d(1.03, 1.03, 1.03)';
      });
    }

    function onEnter() {
      card.classList.remove('js-tilt-reset'); /* snappy, un-eased while actively tracking the cursor */
    }

    function onLeave() {
      if (raf) cancelAnimationFrame(raf);
      card.classList.add('js-tilt-reset');
      card.style.transform = '';
    }

    card.addEventListener('mouseenter', onEnter);
    card.addEventListener('mousemove', onMove);
    card.addEventListener('mouseleave', onLeave);
  }

  /* ---------- Makers UGC feed ----------
     initMakersFeedLoader() lived here until 2026-08-19. The PDP now renders the same
     Instafeed band, so the skeleton swap moved to assets/kitsters-instafeed-loader.js
     and is loaded by sections/kitsters-makers.liquid itself - one definition for both
     bands rather than a per-page copy (CLAUDE.md §10.75). Nothing replaced it here. */

  /* ---------- review card links ---------- */
  function initReviewCardLinks() {
    document.querySelectorAll('.review[data-href]').forEach(function(card) {
      card.addEventListener('click', function(e) {
        /* product link overrides the card link - let it navigate natively */
        if (e.target.closest('.review__product-link')) return;
        window.location.href = card.dataset.href;
      });
      card.addEventListener('keydown', function(e) {
        if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('.review__product-link')) {
          e.preventDefault();
          window.location.href = card.dataset.href;
        }
      });
    });
  }

  /* ---------- 18. Gift the magic - festival ticker + 3-D gift card ----------
     The section is already correct server-side (Liquid picks the first future
     festival), but a cached page can be stale, so the client re-picks from the
     same block list and then runs the per-second ticker. */
  function initGiftMagic() {
    var sec = document.querySelector('[data-kgm]');
    if (!sec) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* --- festivals --- */
    var fests = [];
    var raw = sec.querySelector('[data-kgm-festivals]');
    if (raw) {
      try { fests = JSON.parse(raw.textContent) || []; } catch (err) { fests = []; }
    }

    var main = sec.querySelector('[data-kgm-main]');
    var evergreen = sec.querySelector('[data-kgm-evergreen]');
    var rail = sec.querySelector('[data-kgm-rail]');
    var railList = sec.querySelector('[data-kgm-rail-list]');
    var timer = null;

    function setText(sel, val) {
      var el = sec.querySelector(sel);
      if (el) el.textContent = val;
    }
    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function render() {
      if (timer) { clearInterval(timer); timer = null; }

      var now = Date.now();
      var upcoming = fests
        .map(function (f) {
          // Local midnight+9h, matching the Liquid side's `<date> 09:00:00`.
          var t = new Date(String(f.date) + 'T09:00:00').getTime();
          return { f: f, t: t };
        })
        .filter(function (x) { return !isNaN(x.t) && x.t > now; })
        .sort(function (a, b) { return a.t - b.t; });

      if (!upcoming.length) {
        if (main) main.hidden = true;
        if (rail) rail.hidden = true;
        if (evergreen) evergreen.hidden = false;
        return;
      }

      var primary = upcoming[0].f;
      var target = upcoming[0].t;
      if (evergreen) evergreen.hidden = true;
      if (main) main.hidden = false;

      setText('[data-kgm-date]', 'Next up · ' + (primary.dateLabel || ''));
      setText('[data-kgm-name]', primary.name || '');
      setText('[data-kgm-line]', primary.line || '');
      setText('[data-kgm-cta-label]', primary.cta || 'Shop festive gifts');

      var icon = sec.querySelector('[data-kgm-icon]');
      if (icon) icon.className = 'ph ' + (primary.icon || 'ph-gift');
      var cta = sec.querySelector('[data-kgm-cta]');
      if (cta && primary.link) cta.setAttribute('href', primary.link);

      // Rail - the next three after the primary.
      if (rail && railList) {
        // 4, not 3: on desktop the rail renders as a vertical calendar list and
        // is what stops the yellow half falling short of the taller gift half.
        var rest = upcoming.slice(1, 5);
        if (!rest.length) {
          rail.hidden = true;
        } else {
          rail.hidden = false;
          railList.textContent = '';
          rest.forEach(function (x) {
            var li = document.createElement('li');
            li.className = 'kgm__chip';
            var i = document.createElement('i');
            i.className = 'ph ' + (x.f.icon || 'ph-calendar-dots');
            i.setAttribute('aria-hidden', 'true');
            var name = document.createElement('span');
            name.className = 'kgm__chip-name';
            name.textContent = x.f.name || '';
            var date = document.createElement('span');
            date.className = 'kgm__chip-date';
            date.textContent = x.f.dateLabel || '';
            li.appendChild(i);
            li.appendChild(name);
            li.appendChild(date);
            railList.appendChild(li);
          });
        }
      }

      var dEl = sec.querySelector('[data-kgm-d]'), hEl = sec.querySelector('[data-kgm-h]'),
          mEl = sec.querySelector('[data-kgm-m]'), sEl = sec.querySelector('[data-kgm-s]');

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { render(); return; }   // festival passed while the tab was open
        var d = Math.floor(diff / 86400000); diff -= d * 86400000;
        var h = Math.floor(diff / 3600000);   diff -= h * 3600000;
        var m = Math.floor(diff / 60000);     diff -= m * 60000;
        var s = Math.floor(diff / 1000);
        if (dEl) dEl.textContent = String(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      tick();
      timer = setInterval(tick, 1000);
    }
    render();

    /* --- 3-D gift card: pointer tilt, idle sway otherwise --- */
    var card = sec.querySelector('[data-kgm-card]');
    if (!card || reduced) return;
    var restore = null;
    card.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      card.classList.remove('is-idle');
      card.style.transition = 'transform .1s linear';
      card.style.transform = 'perspective(1000px) rotateY(' + (px * 24) + 'deg) rotateX(' + (-py * 18) + 'deg) scale(1.04)';
    });
    card.addEventListener('pointerleave', function () {
      card.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
      card.style.transform = '';
      clearTimeout(restore);
      restore = setTimeout(function () {
        if (!card.matches(':hover')) {
          card.classList.add('is-idle');
          card.style.transition = '';
          card.style.transform = '';
        }
      }, 640);
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    document.documentElement.classList.add('kh-anim');
    initReveal();
    initAnnouncement();
    initDrawer();
    initHero();
    initCart();
    initWishlist();
    initNewsletter();
    initEta();
    initBackToTop();
    initWordmarkFill();
    initCorpCounters();
    initFooterNewsletter();
    initScrollCarousels();
    initReviewCardLinks();
    initStoryTilt();
    initGiftMagic();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
